module.exports = __webpack_public_path__ + "static/media/main-screen-card-happy-trails.fc64efb2.png";